import { IZoneGeometrySchema, IZonePropertiesSchema } from '../zone-schema.interface';

type ICreateZoneProperties = Omit<IZonePropertiesSchema, 'tags'> & {
    tags?: string[];
};

export interface ICreateZoneInput {
    type: string;
    geometry: IZoneGeometrySchema;
    properties: ICreateZoneProperties;
}
